import React from 'react';
import Footer from './widget/footer.jsx';
import '../styles/default.scss';
import Router from '../route/router';

class AppComponent extends React.Component {
    render() {
        return (
            <div className="index">
                <Router />
                <Footer />
            </div>
        );
    }
}

AppComponent.defaultProps = {};

export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/Main.js